import React, { useEffect } from "react"
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { verifiedAddress } from "../../redux/features/loginSlice";

const Addverfication = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    useEffect(() => {
        dispatch(verifiedAddress(true))
        navigate("/home")
    },[dispatch])
    return (
        <div className="loading-box" style={{ backgroundColor: "#ffffff" }}>
      <div className="lds-roller">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      <div className="loading lds-roller">Loading...</div>
    </div>
    )
}

export default Addverfication
